import { createSlice } from "@reduxjs/toolkit";
import { fetchOutstandingPdc } from "./outstandingPdcThunk";

const initialState = {
  banks: [],
  rows: [],
  grandStartingTotal: 0,
  grandClosingTotal: 0,
  loading: false,
};

const outstandingPdcSlice = createSlice({
  name: "outstandingPdc",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOutstandingPdc.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOutstandingPdc.fulfilled, (state, action) => {
        state.loading = false;
        state.banks = action.payload.banks || [];
        state.rows = action.payload.rows || [];
        state.grandStartingTotal = action.payload.grand_starting_total || 0;
        state.grandClosingTotal = action.payload.grand_closing_total || 0;
      })
      .addCase(fetchOutstandingPdc.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default outstandingPdcSlice.reducer;
